(function () {
  "use strict";

  var FORM_ID = "ContactForm";
  var STORE_KEY = "cf_klaviyo_pending";
  // pending の生存上限（ミリ秒）。submit したが成功描画に到達しなかった値が
  // sessionStorage に滞留し、共有端末で「別人の ?contact_posted=true 再表示」に
  // 乗ってしまう窓を縮める TTL。10 分を超えた pending は破棄する。
  var PENDING_TTL_MS = 10 * 60 * 1000;
  // デバッグ出力は既定 OFF（本番では email/name/phone の PII を console に出さない）。
  // 検証時のみ URL に ?klaviyo_debug=1 を付けると有効化される。
  var DEBUG = (function () {
    try {
      return window.location.search.indexOf("klaviyo_debug=1") >= 0;
    } catch (e) {
      return false;
    }
  })();

  // 成功時だけ描画される Dawn ネイティブの成功メッセージ要素を成功マーカーに使う。
  // contact-form.liquid 側で同時に出力する data-cf-posted="true" を第一優先で見る。
  // フォールバックの .contact .form-status.form__message は将来 Dawn 更新で
  // data 属性が消えた場合のみの保険（通常は使われない）。エラー時の h2(form__message 無し)
  // / div(form-status 無し) はこの AND セレクタに一致しないため誤検知しない。
  var SUCCESS_SELECTORS = [
    "[data-cf-posted='true']",
    ".contact .form-status.form__message"
  ];

  function findSuccessMarker() {
    for (var i = 0; i < SUCCESS_SELECTORS.length; i++) {
      var el = document.querySelector(SUCCESS_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function readValue(id) {
    var el = document.getElementById(id);
    return el && typeof el.value === "string" ? el.value : "";
  }

  // --- フェーズ1: submit 直前に入力値を sessionStorage へ退避 ---
  // フルページ POST 後の ?contact_posted=true 再表示ではフォーム値がクリアされるため、
  // 種別・連絡先を発火に乗せるには submit 時の退避が必須（postpartum フローと同手法）。
  // submit ハンドラは送信開始前に同期実行されるため、hCaptcha /challenge を挟んでも
  // 退避自体は初回 submit 時に完了している。同一オリジン sessionStorage は /challenge
  // 遷移をまたいで生存する。
  function attachSubmitCapture() {
    var form = document.getElementById(FORM_ID);
    if (!form) return; // 防御的: フォームが無いページでは何もしない
    form.addEventListener("submit", function () {
      try {
        var payload = {
          email: readValue("ContactForm-email"),
          name: readValue("ContactForm-name"),
          phone: readValue("ContactForm-phone"),
          inquiry_type: readValue("ContactForm-inquiry-type"),
          message: readValue("ContactForm-body").trim(),
          ts: Date.now()
        };
        sessionStorage.setItem(STORE_KEY, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage 不可（プライベートモード等）でも送信フローは止めない
      }
    });
  }

  // --- フェーズ2: 成功描画を検知して Klaviyo へ identify + track → 即クリア ---
  function fireOnSuccess() {
    if (!findSuccessMarker()) return; // 成功再表示でなければ何もしない（防御的）

    var raw;
    try {
      raw = sessionStorage.getItem(STORE_KEY);
    } catch (e) {
      raw = null;
    }
    if (!raw) return; // 既に発火済み or 退避データ無し（リロード再発火を防止）

    // 読めた時点で即クリア。以降のリロード/ブックマーク再表示での二重 track を防ぐ。
    // sessionStorage はタブ単位スコープのため、別タブ/別セッションでの再表示では
    // そもそも pending が無く発火しない（取りこぼし＝安全側に倒れる）。
    try {
      sessionStorage.removeItem(STORE_KEY);
    } catch (e) {}

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!data || typeof data !== "object") return;

    // TTL チェック: 古すぎる pending（未成功で滞留した可能性が高い）は破棄して発火しない。
    // 共有端末で前ユーザーの値が後ユーザーの成功描画に乗るリスクを縮小する。
    var ts = typeof data.ts === "number" ? data.ts : 0;
    if (!ts || Date.now() - ts > PENDING_TTL_MS) return;

    try {
      // ★ _learnq 未ロードでも落とさない: キュー配列を必ず保証してから push。
      //   既存 window.trackKlaviyoEvent / identifyKlaviyoCustomer は !window._learnq で
      //   早期 return する実装のため、取りこぼし防止のため _learnq へ直接 push する。
      window._learnq = window._learnq || [];

      var email = data.email || "";

      // 1) identify（既存規約: track の前に identify）。$email は $ プレフィックス。
      if (email) {
        window._learnq.push(["identify", { $email: email }]);
      }

      // 2) track: イベント名 = Title Case / プロパティキー = snake_case。
      //    select のラベル値はそのまま value に入れる（既存 booking 系と同方針）。
      //    Flow の Email 宛先解決のため email を track プロパティにも明示同梱する。
      var props = {
        inquiry_type: data.inquiry_type || "Unknown",
        email: email,
        name: data.name || "",
        phone: data.phone || "",
        has_message: !!data.message,
        page: window.location.pathname
      };
      window._learnq.push(["track", "Submitted Contact Form", props]);

      if (DEBUG && window.console && console.log) {
        console.log("[Klaviyo] Tracked: Submitted Contact Form", props);
      }
    } catch (e) {
      // 既存規約: 失敗は warn のみ。送信フローは止めない。
      if (window.console && console.warn) {
        console.warn("[Klaviyo] Contact Form track failed:", e);
      }
    }
  }

  function init() {
    attachSubmitCapture();
    fireOnSuccess();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
